// extracted by mini-css-extract-plugin
export default {"Modal":"EventgroupsModal_Modal__DxNo-","ModalBase":"EventgroupsModal_ModalBase__WYW12","ModalHeader":"EventgroupsModal_ModalHeader__yKW6w"};